/**
 * @module estimateStatus
 * @description A list of estimateStatus
 */

export const estimateStatus = [
	'draft',
	'sent',
	'invoiced',
	'accepted',
	'declined',
	'expired',
] as const;
export type EstimateStatus = (typeof estimateStatus)[number];
